export const angular = 'Angular';
export const apache = 'Apache';
export const bookmarklet = 'Bookmarklet';
export const broccoli = 'Broccoli';
export const chrome = 'Chrome';
export const cli = 'CLI';
export const firefox = 'Firefox';
export const googleAppsScript = 'Google Apps Script';
export const grunt = 'Grunt';
export const gulp = 'Gulp';
export const illustrator = 'Illustrator';
export const java = 'Java';
export const javascript = 'JavaScript';
export const linux = 'Linux';
export const mac = 'macOS';
export const nginx = 'NGINX';
export const node = 'Node';
export const php = 'PHP';
export const python = 'Python';
export const ruby = 'Ruby';
export const service = 'Service';
export const windows = 'Windows';
export const wordpress = 'WordPress';
